import React from 'react'
// context
import CreateReviewAPI from 'containers/Review/CreateReview/layers/API'
import CreateReviewBL from 'containers/Review/CreateReview/layers/BL'
// components
import CreateReviewDrawer from 'components/Modals/CreateReviewModal'

const CreateReviewContainer = () => (
  <CreateReviewAPI>
    <CreateReviewBL>
      <CreateReviewDrawer />
    </CreateReviewBL>
  </CreateReviewAPI>
)

export default CreateReviewContainer
